import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import { faChevronRight, faSearch } from "@fortawesome/free-solid-svg-icons";
//import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
//import styles from "../../masters/master.css";
import apiUrl from "../../apiUrlConstant";
//import CreatableSelect from "react-select/creatable";
import { Redirect, withRouter, Link } from "react-router-dom";
import Select from "react-select";
import * as Yup from "yup";
import { getUserType } from "../../utils/index";
import { PopupMessage } from "../../utils/utils";
import Popup from "reactjs-popup";
import DataTable, {
  createTheme,
  defaultThemes,
} from "react-data-table-component";
import datatableOptions from "../../layout/datatableConstants";
import SimpleReactValidator from "simple-react-validator";
//import { Chart } from "react-google-charts";
import {
  Chart as ChartJS,
  LineController,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line, Bar } from "react-chartjs-2";
import { Chart } from "react-google-charts";
import { counter } from "@fortawesome/fontawesome-svg-core";
ChartJS.register(
  LineController,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// const reportFilterForm = Yup.object().shape({
//   countryId: Yup.string().required("Required"),
//   stateId: Yup.string().required("Required"),
//   districtId: Yup.string().required("Required"),
//   cityId: Yup.string().required("Required"),
// });
const labels = [
  "Expiring in 3 Months",
  "Expiring in 6 Months",
  "Expiring in 9 Months",
  "Expiring in 12 Months",
  "Expiring in over 12 Months",
];

const Checkbox = ({ id, type, name, handleClick, isChecked, attr }) => {
  return (
    <input
      id={id}
      name={name}
      type={type}
      onChange={handleClick}
      checked={isChecked}
      data-attr={attr}
    />
  );
};

//['January', 'February', 'March', 'April', 'May', 'June', 'July'];
if (getUserType() == "Landlord") {
  var reportFilterForm = Yup.object().shape({
    // assetId: Yup.string().required("Required"),
    //stateId: Yup.string().required("Required"),
    //districtId: Yup.string().required("Required"),
    //cityId: Yup.string().required("Required"),
  });
} else if (getUserType() == "Occupier") {
  var reportFilterForm = Yup.object().shape({
    // brandId: Yup.number().required("Required"),
    // stateId: Yup.string().required("Required"),
    // districtId: Yup.string().required("Required"),
    // cityId: Yup.string().required("Required"),
  });
} else {
  var reportFilterForm = Yup.object().shape({
    // countryId: Yup.string().required("Required"),
    // stateId: Yup.string().required("Required"),
    // districtId: Yup.string().required("Required"),
    // cityId: Yup.string().required("Required"),
  });
}

var reportFilterForm = Yup.object().shape({
  chargeType: Yup.string().required("Required"),
  financialYearOne: Yup.string().required("Required"),
  //receiptModeSelected: Yup.string().required("Required"),
  //receiptMode: Yup.string().required("Required"),
  paymentInstrumentNo: Yup.string().required("Required"),
  applyOpenInvoiceSelected: Yup.string().required("Required"),
  //applyOpenInvoice:Yup.string().required("Required"),
  //openInvoiceNumberSelected:Yup.string().required("Required"),
  occupierId: Yup.string().required("Required"),
  financialInstitutionName: Yup.string().required("Required"),
  branchName: Yup.string().required("Required"),
  invoiceDescription: Yup.string().required("Required"),
  //financialYearOne: Yup.string().required("Required"),
  chargeAmount: Yup.string().required("Required"),
});

let monthsArr = [];
var i = 0;
for (; i <= 12; i++) {
  monthsArr.push({ id: i, value: i });
}

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class DepositComponent extends React.Component {
  groupId = { value: "" };
  state = {
    selectedStatus: 0,
    landloardArr: [],
    assetArr: [],
    subAssetArr: [],
    towerArr: [],
    companyArr: [],
    cityList: [],
    occupierList: [],
    leaseList: [],
    landloardList: [],
    assetsList: [],
    tableTOShow: "RENT",
    companyDetails: {
      companyPan: "",
    },
    disableInvoiceField: true,
    disableAdjustmentField: true,
    formResponseData: [],
    activeInvoiceList: [],
    invoiceList: {},
    initialValues: {
      chargeTypeSelected: "",
      frequencySelected: "",
      chargeType: "",
      landloardName: "",
      landloardId: "",
      subAssetName: "",
      subAssetId: "",
      companyName: "",
      companyId: "",
      cityName: "",
      cityId: "",
      occupierName: "",
      occupierId: "",
      companyPan: "",
      leaseCode: "",
      leaseId: "",
      receiptModeSelected: "",
      receiptMode: "",
      paymentInstrumentNo: "",
      applyOpenInvoiceSelected: "",
      applyOpenInvoice: "",
      openInvoiceNumberSelected: "",
      openInvoiceNumber: "",
      financialInstitutionName: "",
      branchName: "",
      invoiceDescription: "",
      financialYearOne: "",
      chargeAmount: "",
      financialYearOne: "",
      fromData: "",
      toDate: "",
      customPeriod: "",
      entryType: "",
    },
    notesCount: {
      0: 0,
      1: 0,
      2: 0,
      3: 0,
    },
    datatableList: [],
    totalRows: 0,
    loading: false,
    perPage: 10,
    pageNo: 1,
    showStatusOption: false,
    tableCounter: Math.round(),
  };

  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/countries`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/brand/get-all-brands`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          brandList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/lease-report/get-lease-status`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          leaseStatus: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/lease-report/get-occupier-landloard`, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          landloardList: data.landloardList,
          //occupierList: data.occupierList,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/transaction/get-active-invoices`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data, "data....");
        this.setState({
          activeInvoiceList: data,
          //occupierList: data.occupierList,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    // fetch(`${apiUrl.apiUrl.url}/transaction/get-credit-list?status=0`, { headers })
    // 	.then((response) => {
    // 		return response.json();
    // 	})
    // 	.then((data) => {
    // 		//console.log(data,"data");
    // 		this.setState({
    // 			formResponseData: data.lists,
    // 			notesCount: data.status
    // 		});
    // 	})
    // 	.catch((error) => {
    // 		console.log(error);
    // 	});

    this.getAssetsList("", "", true);
  }

  componentDidUpdate() { }

  constructor(props) {
    super(props);
    
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });

  }

  getAssetsList = (input, e, cust) => {
    if (
      (typeof e != "undefined" && e.action == "input-change") ||
      cust === true
    ) {
      fetch(
        `${apiUrl.apiUrl.url}/unit-detail/get-all-assets?city_id=` +
        this.state.initialValues.cityId +
        `&assetName=` +
        input,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("data", data);
          this.setState({
            assetsList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  handleCalenderOnBlur = () => {
    this.state.initialValues.financialYearOne = this.formatDate(
      this.state.financialYearOne
    );
    this.state.initialValues.fromData = this.formatDate(
      this.state.financialYearOne
    );
  };

  handleToCalenderOnBlur = () => {
    this.state.initialValues.toDate = this.formatDate(
      this.state.financialYearTwo
    );
  };

  handleCalculation = (e, index, values) => {
    var total = 0;
    for (const value in values.amount) {
      total += parseInt(values.amount[value]);
    }
    //console.log(total, "total", this.state.formResponseData[index].variance )
    if (typeof index == "undefined") {
      this.setState({ totalInvoiceAmount: total });
    } else {
      var formData = this.state.formResponseData;
      formData[index].variance =
        parseFloat(formData[index].net_charge_amount) - e.target.value;

      this.setState({ totalInvoiceAmount: total, formResponseData: formData }); //, `formResponseData${}` : totalVariance
    }
  };

  valueChangeTower = (newValue, actionMeta) => {
    fetch(
      `${apiUrl.apiUrl.url}/asset/get-tower-occupiers?id=` + newValue.value,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data, "data");
        this.setState({
          occupierList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(
      `${apiUrl.apiUrl.url}/landlord/get-group-companies?id=` +
      this.state.initialValues.groupId +
      `&tower=` +
      newValue.value,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          companyArr: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getGridList = (status) => {
    let pgNo = this.state.pageNo;
    let perPage = this.state.perPage;

    var prm = Object.entries(this.state.initialValues)
      .map(([key, val]) => `${key}=${val}`)
      .join("&");
    console.log(prm, "prm");

    fetch(
      `${apiUrl.apiUrl.url}/transaction/get-deposit-ledger?status=` +
      status +
      `&page=` +
      pgNo +
      `&per_page=` +
      perPage +
      `&type=general&` +
      prm,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((cdata) => {
        //console.log(data,"data"); return false;
        this.setState({
          //formResponseData: cdata.lists,
          // notesCount: cdata.status,
          datatableList: cdata.lists,
          totalRows: parseInt(cdata.total, 10),
          //showStatusOption:false
        });

        if (pgNo == 1) {
          this.setState({ tableCounter: Math.random() });
          this.setState({});
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  valueChangeSubAsset = (newValue, actionMeta) => {
    this.state.initialValues.subAssetId = newValue.value;
    this.state.initialValues.subAssetName = newValue.label;
    this.setState({});
    fetch(`${apiUrl.apiUrl.url}/asset/sub-asset-towers?id=` + newValue.value, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          towerArr: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  valueFrequencyChange = (newValue, actionMeta) => {
    this.state.initialValues.frequencySelected = newValue.value;
    this.setState({});
  };

  valueChangeChargeType = (newValue, actionMeta) => {
    console.log(newValue);
    this.state.initialValues.chargeTypeSelected = newValue.value;
    this.state.initialValues.chargeType = newValue.value;
    this.setState({});
  };

  valueChangeOpenInvoice = (newValue, actionMeta) => {
    console.log(newValue);
    this.state.initialValues.applyOpenInvoiceSelected = newValue.value;
    this.state.initialValues.applyOpenInvoice = newValue.value;

    if (newValue.value === "Yes") {
      this.state.disableInvoiceField = false;
      this.state.disableAdjustmentField = true;
      this.state.initialValues.adjustmentLogic = "";
    } else {
      this.state.disableAdjustmentField = false;
      this.state.disableInvoiceField = true;
      this.state.initialValues.openInvoiceNumberSelected = ""; //   openInvoiceNumberSelected = "";
      this.state.initialValues.openInvoiceNumberId = "";
    }

    this.setState({});
  };

  valueChangeOpenInvoiceNumber = (newValue, actionMeta) => {
    console.log(newValue, "valueChangeOpenInvoiceNumber");
    this.state.initialValues.openInvoiceNumberSelected = newValue.label;
    this.state.initialValues.openInvoiceNumberId = newValue.value;
    this.state.initialValues.openInvoiceAmt = newValue.amt;
    this.setState({});
  };

  valueChangeReceiptMode = (newValue, actionMeta) => {
    console.log(newValue);
    this.state.initialValues.receiptModeSelected = newValue.value;
    this.state.initialValues.receiptMode = newValue.value;
    this.setState({});
  };

  valueChangeAdjustmentLogic = (newValue) => {
    console.log(newValue, "new values");
    this.state.initialValues.adjustmentLogic = newValue.value;
    this.setState({});
  };

  valueChangeOccupier = (newValue, actionMeta) => {
    this.state.initialValues.occupierId = newValue.value;
    this.state.initialValues.occupierName = newValue.label;
    this.setState({});
    fetch(
      `${apiUrl.apiUrl.url}/asset/get-occupier-leases?id=` +
      newValue.value +
      `&tower=` +
      this.state.initialValues.towerId,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data, "ata");
        this.setState({
          leaseList: data,
        });
        // this.state.initialValues.companyPan = data.data.companyPan;
        // this.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
  };

  valueChangeCompany = (newValue, actionMeta) => {
    this.state.initialValues.companyId = newValue.value;
    this.state.initialValues.companyName = newValue.label;
    this.setState({});
  };

  valueChangeAsset = (newValue, actionMeta) => {
    this.state.initialValues.assetId = newValue.value;
    this.state.initialValues.assetName = newValue.label;
    this.setState({});
    //landlord-group/fetch-landlord-list
    fetch(`${apiUrl.apiUrl.url}/asset/asset-sub-assets?id=` + newValue.value, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          subAssetArr: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleChangeChk = (val) => {
    console.log(val, "clickec");
  };

  valuePeriodChange = (e) => {
    //customPeriod
    this.state.initialValues.customPeriod = e.value;
    this.setState({});
  };

  valueChangeEntryType = (e) => {
    //customPeriod
    this.state.initialValues.entryType = e.value;
    this.setState({});
  };

  handleChangeLandlord = (newValue, actionMeta) => {
    this.state.initialValues.groupId = newValue.value;
    this.state.initialValues.groupName = newValue.label;
    this.setState({});

    //landlord-group/fetch-landlord-list
    fetch(
      `${apiUrl.apiUrl.url}/asset/fetch-landlord-all-assets?id=` +
      newValue.value,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          assetArr: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(
      `${apiUrl.apiUrl.url}/landlord/get-group-companies?id=` + newValue.value,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          companyArr: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleChangeClientGroup = (newValue, actionMeta) => {
    //console.group("Value Changed", newValue, "actionmeta", actionMeta);
    this.state.initialValues.groupId = newValue.value;
    this.state.initialValues.groupName = newValue.label;
    this.setState({});
    // console.log(newValue, "ddd");
    // console.log(`action: ${actionMeta}`);
    // console.groupEnd();
  };

  redirectAfterSave = () => {
    this.setState({
      messsagePopup: false,
      popupMessageContent: "",
    });
  };

  exportReport = () => {
    var prm = Object.entries(this.state.initialValues)
      .map(([key, val]) => `${key}=${val}`)
      .join("&");
    console.log(prm, "prm");

    fetch(
      `${apiUrl.apiUrl.url}/transaction/get-deposit-ledger-excel?status=1&type=general&` +
      prm,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((cdata) => {
        window.location.href = `${apiUrl.apiUrl.url +
          "/lease-report/download-file?path=" +
          cdata.filename
          }`;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  exportReportToPDF = () => {
    var prm = Object.entries(this.state.initialValues)
      .map(([key, val]) => `${key}=${val}`)
      .join("&");
    console.log(prm, "prm");

    fetch(
      `${apiUrl.apiUrl.url}/transaction/get-deposit-ledger-excel?fileType=pdf&status=1&type=general&` +
      prm,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((cdata) => {
        window.location.href = `${apiUrl.apiUrl.url +
          "/lease-report/download-file?path=" +
          cdata.filename
          }`;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/transactions/generate" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    const handlePerRowsChange = async (newPerPage, page) => { };

    const handlePageChange = (page) => {
      this.setState({ pageNo: page }, () => {
        this.getDebitList(this.state.selectedStatus);
      });
    };

    const columns = [
      {
        name: "Sr No",
        //selector: row => row.lease_id,
        cell: (row, index) => index + 1,
      },
      {
        name: "Lease ID",
        selector: (row) => row.leaseName,
        wrap: true,
      },
      {
        name: "Asset Name",
        selector: (row) => row.assetName,
        wrap: true,
      },
      {
        name: "Occupier Name",
        selector: (row) => row.occupierName,
        wrap: true,
      },
      {
        name: "Landlord Name",
        selector: (row) => row.landlordName,
        wrap: true,
      },
      {
        name: "Brand Name",
        selector: (row) => row.brandName,
        wrap: true,
      },
      {
        name: "Charge Type",
        selector: (row) => row.chargeType,
        wrap: true,
        sortable: true,
      },

      {
        name: "Charge Period",
        selector: (row) => row.chargeType,
        wrap: true,
        sortable: true,
      },
      {
        name: "Document Type",
        selector: (row) => row.documentType,
        wrap: true,
        sortable: true,
      },

      {
        name: "Document Date",
        selector: (row) => row.documentDate,
        wrap: true,
        sortable: true,
      },

      {
        name: "Document Number",
        selector: (row) => row.documentNumber,
        wrap: true,
        sortable: true,
      },

      {
        name: "Document Description",
        selector: (row) => row.documentDesc,
        wrap: true,
        sortable: true,
      },

      {
        name: "Document Amount",
        selector: (row) => row.amt,
        wrap: true,
        sortable: true,
      },

      {
        name: "Balance",
        selector: (row) => row.bal,
        wrap: true,
        sortable: true,
      },
    ];

    const handleRowSelected = (state) => {
      console.log(state.selectedRows.length);
      console.log(state.selectedRows);

      var invoiceListObj = {};
      if (state.selectedRows.length > 0) {
        state.selectedRows.forEach(function (items) {
          let leaseId = items["lease_id"];
          let pId = items["transactionId"];

          if (typeof invoiceListObj[leaseId] == "undefined") {
            invoiceListObj[leaseId] = {};
          }

          invoiceListObj[leaseId][pId] = true;
        });

        this.state.showStatusOption = true;
      } else {
        this.state.showStatusOption = false;
      }

      this.state.invoiceList = invoiceListObj;
      this.setState({});
    };

    return (
      <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>TRANSACTIONS</li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>LEDGERS</li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <a href="javascript:void(0);">DEPOSIT LEDGERS</a>
              </li>
            </ul>
          </div>
        </div>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          //validationSchema={reportFilterForm}
          onReset={(values, actions) => {
            this.state.brandSelected = [];
            for (const [key, value] of Object.entries(
              this.state.initialValues
            )) {
              this.state.initialValues[key] = "";
            }
            this.state.counter = Math.random();
            this.setState({});
          }}
          onSubmit={(values, actions) => {
            var self = this;

            if (!this.validator.allValid()) {
              this.validator.getErrorMessages();
              this.validator.showMessages();
              return false;
            }

            this.getGridList(0);
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <>

              <div className="unitFormContainerNew">
                <Form autoComplete="off">
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">

                      {/* Landlord Group */}
                      <div className="newGridSectionInner">
                        <label>Landlord Group</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="landlordId"
                            isSearchable="true"
                            onChange={(e) => {
                              this.handleChangeLandlord(e);
                            }}
                            value={{
                              label: this.state.initialValues.groupName,
                              value: this.state.initialValues.groupId,
                            }}
                            options={this.state.landloardList.map((item) => ({
                              label: item.text,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="groupId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      {/* Landlord Asset Name */}
                      <div className="newGridSectionInner">
                        <label>Landlord Asset Name</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="assetName"
                            onChange={(e) => {
                              this.valueChangeAsset(e);
                            }}
                            value={{
                              label: this.state.initialValues.assetName,
                              value: this.state.initialValues.assetId,
                            }}
                            options={this.state.assetArr.map((item) => ({
                              label: item.asset_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="assetId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      {/* Sub Asset Name */}
                      <div className="newGridSectionInner">
                        <label>Sub Asset Name</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="subAssetName"
                            onChange={(e) => {
                              this.valueChangeSubAsset(e);
                            }}
                            value={{
                              label: this.state.initialValues.subAssetName,
                              value: this.state.initialValues.subAssetId,
                            }}
                            options={this.state.subAssetArr.map((item) => ({
                              label: item.sub_asset_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="subAssetName"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      {/* Tower Name */}
                      <div className="newGridSectionInner">
                        <label>Tower Name <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="towerId"
                            onChange={(e) => {
                              this.state.initialValues.towerId = e.value;
                              this.valueChangeTower(e);
                            }}
                            options={this.state.towerArr.map((item) => ({
                              label: item.tower_name,
                              value: item.id,
                            }))}
                          />
                          {this.validator.message("Tower name", this.state.initialValues.towerId, "required", { className: "text-danger" })}
                        </div>
                      </div>

                      {/* Landlord Company Name */}
                      <div className="newGridSectionInner">
                        <label>Landlord Company Name <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="companyId"
                            onChange={(e) => {
                              this.valueChangeCompany(e);
                            }}
                            value={{
                              label: this.state.initialValues.companyName,
                              value: this.state.initialValues.companyId,
                            }}
                            options={this.state.companyArr.map((item) => ({
                              label: item.company_name,
                              value: item.id,
                            }))}
                          />
                          {this.validator.message("Landlord Company Name", this.state.initialValues.companyId, "required", { className: "text-danger" })}
                        </div>
                      </div>

                      {/* Occupier Name */}
                      <div className="newGridSectionInner">
                        <label>Occupier Name <span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="occupierId"
                            onChange={(e) => {
                              this.valueChangeOccupier(e);
                            }}
                            value={{
                              label: this.state.initialValues.occupierName,
                              value: this.state.initialValues.occupierId,
                            }}
                            options={this.state.occupierList.map((item) => ({
                              label: item.company_name,
                              value: item.id,
                            }))}
                          />
                          {this.validator.message("Occupier Name", this.state.initialValues.occupierName, "required", { className: "text-danger" })}
                        </div>
                      </div>

                      {/* Occupier Leases */}
                      <div className="newGridSectionInner">
                        <label>Occupier Leases</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="leaseId"
                            onChange={(e) => {
                              this.state.initialValues.leaseCode = e.label;
                              this.state.initialValues.leaseId = e.value;
                              this.setState({});
                            }}
                            value={{
                              label: this.state.initialValues.leaseCode,
                              value: this.state.initialValues.leaseId,
                            }}
                            options={this.state.leaseList.map((item) => ({
                              label: item.lease_code,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage
                            name="leaseId"
                            component="div"
                            className="text-red"
                          />
                        </div>
                      </div>

                      {/* Ledger Deposit Type */}
                      <div className="newGridSectionInner">
                        <label>Ledger Deposit Type<span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            onChange={(e) => {
                              this.valueChangeChargeType(e);
                            }}
                            value={this.state.chargeTypeSelected}
                            name="chargeType"
                            options={[
                              "RENT Deposit - Refundable - Interest Free",
                              "RENT Deposit - Refundable - Interest Bearing",
                              "RENT Deposit - Non Refundable - Interest Free",
                              "RENT Deposit - Non Refundable - Interest Bearing",
                              "CAM Deposit - Refundable - Interest Free",
                              "CAM Deposit - Refundable - Interest Bearing",
                              "CAM Deposit - Non Refundable - Interest Free",
                              "CAM Deposit - Non Refundable - Interest Bearing",
                              "OTHER Deposit - Electricity Load Deposit – Refundable",
                              "OTHER Deposit - Electricity Load Deposit – Non Refundable",
                              "OTHER Deposit - GAS / PNG Meter",
                              "OTHER Deposit - GAS / PNG Connection Deposit",
                              "OTHER Deposit - Electricity Meter Deposit",
                              "OTHER Deposit - Water Meter Deposit",
                              "OTHER Deposit - Air Conditioing Load Deposit",
                              "OTHER Deposit - Air Conditioning Meter Deposit",
                              "OTHER Deposit - Fitout Deposit",
                              "OTHER Deposit - Storage Deposit",
                            ].map((item) => ({
                              label: item,
                              value: item,
                            }))}
                          />
                          {this.validator.message("Ledger Deposit Type", this.state.initialValues.chargeTypeSelected, "required", { className: "text-danger" })}
                        </div>
                      </div>

                      {/* From Date */}
                      <div className="newGridSectionInner">
                        <label>From Date</label>
                        <div className="position-relative">
                          <DatePicker
                            onChange={(date) =>
                              this.setState({ financialYearOne: date })
                            }
                            onBlur={this.handleCalenderOnBlur}
                            dateFormat="dd/MM/yyyy"
                            selected={this.state.financialYearOne}
                            onCalendarClose={this.handleCalenderOnBlur}
                          />
                          
                        </div>
                      </div>

                      {/* To Date */}
                      <div className="newGridSectionInner">
                        <label>To Date</label>
                        <div className="position-relative">
                          <DatePicker
                            onChange={(date) =>
                              this.setState({ financialYearTwo: date })
                            }
                            onBlur={this.handleToCalenderOnBlur}
                            dateFormat="dd/MM/yyyy"
                            selected={this.state.financialYearTwo}
                            onCalendarClose={this.handleToCalenderOnBlur}
                          />
                           
                        </div>
                      </div>

                      {/* Custom Periods */}
                      <div className="newGridSectionInner">
                        <label>Custom Periods</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            onChange={(e) => {
                              this.valuePeriodChange(e);
                            }}
                            value={{
                              label: this.state.initialValues.customPeriod,
                              value: this.state.initialValues.customPeriod,
                            }}
                            name="customPeriod"
                            options={[
                              "CURRENT CY",
                              "LAST 3 MONTHS",
                              "LAST 6 MONTHS",
                              "LAST 9 MONTHS",
                            ].map((item) => ({
                              label: item,
                              value: item,
                            }))}
                          />
                          
                        </div>
                      </div>

                    </div>
                    <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                      <button type="submit" d1isabled={isSubmitting} className="add_button big_button">
                        VIEW
                      </button>
                      <button type="reset" onClick={this.selectAll} className="reset_button">
                        Reset
                      </button>
                    </div>
                  </div>
                </Form>
              </div>
            </>
          )}
        </Formik>

        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>

        <DataTable
          title="Transaction History"
          key={this.state.tableCounter}
          columns={columns}
          data={this.state.datatableList}
          customStyles={datatableOptions.datatableOptions.customStyle}
          progressPending={this.state.loading}
          pagination
          paginationServer
          paginationTotalRows={this.state.totalRows}
          onChangeRowsPerPage={handlePerRowsChange}
          subHeader
          //subHeaderComponent={subHeaderComponentMemo}
          onChangePage={handlePageChange}
          paginationComponentOptions={
            datatableOptions.datatableOptions.paginationOptions
          }
          paginationRowsPerPageOptions={[1, 3, 5, 10, 25, 50, 100]}
        //selectableRows
        //onSelectedRowsChange={handleRowSelected}
        //contextActions={contextActions}
        />

        {this.state.datatableList.length > 0 && (
          <div className="btnContainer">
            <button type="button" onClick={this.exportReport}>
              Download Excel
            </button>
            <button type="button" onClick={this.exportReportToPDF}>
              Download PDF
            </button>
          </div>
        )}
      </>
    );
  }
}

export default withRouter(DepositComponent);
